import CrudRepository from './CrudRepository'
export default class FinancialReportsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/financeReport/web')
  }
}
